<template>
  <div class="app-activation-select-mnp">
    <TariffBox
    :showTariffSelect="true"
    :disableProviderSelect="false"
    :quickSelectionBrand="quickSelectionBrand"
    :showPriceStarts="noProviderSelected"
    :normalPrice = "promoBenefits.price"
    :promoPrice = "promoBenefits.promoPrice"
    :additionalPriceStairways = "promoBenefits.additionalPriceStairways"
    :startingBonus = "promoBenefits.startingBonus"
    :targetTariff = "targetTariff"
    :targetPromotions = "filteredTargetPromotions"
    :ctaLink = "activationProcessPage"
    process="activation"
  >
    <template v-for="slot in possibleChildSlotsFor('TariffBox')" v-slot:[`${slot.child}`]>
      <slot :name="`${slot.parent}`"></slot>
    </template>
    <div class="tariff" style="min-height: 585px;"></div>
  </TariffBox>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TariffBox from '@/components/checkout/tariff/generic/TariffBox.vue'

export const stepName = 'activationSelectMnp'
export default {
  name: 'ActivationSelectMnp',
  data () {
    return {
      tariffName: '',
      showMoreModal: false,
      basisStartingBonusPromoIds: [100599, 100599]
    }
  },
  created () {
    this.updateCart()
    this.updateActivationLandingStep(this.mnpActive)
  },
  watch: {
    selectedTariffOptionIds: function (v) {
      this.updateCart()
    },
    mnpActive: function (v) {
      this.updateCart()
      this.updateActivationLandingStep(v)
    },
    mnpProvider: function (v) {
      this.updateCart()
    }
  },
  props: {
    quickSelectionBrand: {
      type: String,
      default: ''
    },
    activationProcessPage: {
      type: String,
      default: 'sim-aktivieren/kundendaten'
    }
  },
  components: {
    TariffBox
  },
  methods: {
    ...mapActions('checkoutv2/activation/_cart', { activationCart: 'setActivationCartWithPrefetches' }),
    ...mapMutations('checkoutv2/activation', ['setStep']),
    updateCart () {
      let tariffId = this.selectedTariff ? this.selectedTariff.tariffId : null
      if (this.noProviderSelected) {
        tariffId = null
      }
      const tariffoptionId = this.selectedTariffOptionIds.length > 0 ? this.selectedTariffOptionIds[0] : null
      this.activationCart({ tariffId, tariffoptionId, mnp: this.mnpActive, provider: this.mnpProvider?.key || null })
    },
    updateActivationLandingStep (mnpActive) {
      if (mnpActive) {
        this.setStep('mnpData')
      } else {
        this.setStep('customerData')
      }
    }
  },
  computed: {
    ...mapGetters('checkoutv2/activation/_cart', ['targetTariff', 'targetPromotions', 'promoBenefits', 'selectedTariffOptionIds']),
    ...mapGetters('checkoutv2/activation/_mnpData', {
      mnpActive: 'active',
      mnpProvider: 'provider'
    }),
    ...mapGetters('checkout/tariff', { selectedTariff: 'selectedTariff' }),
    filteredTargetPromotions () {
      return this.targetPromotions.filter(promo => !this.basisStartingBonusPromoIds.includes(promo.promotionId))
    },
    noProviderSelected: function () {
      let tariffId = this.selectedTariff ? this.selectedTariff.tariffId : null
      if (tariffId === '155' && this.mnpActive) {
        tariffId = null
      }
      return this.mnpActive && tariffId === null
    }
  }
}
</script>
